module.exports = __webpack_public_path__ + "img/likesOrderOff.25ae9949.svg";